var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lightbox",class:{
    landscape: _vm.landscape,
    active: _vm.active,
    'portrait': !_vm.landscape,
    'next-slide': _vm.isNext,
    'previous-slide': _vm.isPrev,
    'project-page': _vm.$route.name === 'project'
  },on:{"mousemove":_vm.onMouseMove,"click":_vm.onClick}},[_c('div',{staticClass:"lightbox-project"},[_c('div',{key:_vm.uid,ref:"projects",staticClass:"lightbox-project-inner"},[(_vm.$route.name === 'project' || !_vm.phone)?_c('project',{attrs:{"uid":_vm.uid,"landscape":_vm.landscape},on:{"file-changed":_vm.onFileChanged}}):_vm._l((_vm.projects),function(project){return _c('project',{key:project.uid,attrs:{"uid":project.uid,"landscape":_vm.landscape},on:{"file-changed":_vm.onFileChanged,"next-project":_vm.onNextProject,"previous-project":_vm.onPreviousProject}})})],2)]),_vm._v(" "),(_vm.$route.name === 'project' || !_vm.phone)?_c('div',{staticClass:"lightbox-caption",domProps:{"innerHTML":_vm._s(_vm.currentCaption)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-215f8861","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Lightbox.vue
// module id = 94
// module chunks = 0